// extracted by mini-css-extract-plugin
module.exports = {"languageSelectWrapper":"LanguageSelect_languageSelectWrapper__VZFH5","customSelect":"LanguageSelect_customSelect__UCKNd"};